import 'admin-lte';
import 'bootstrap';
import 'bootstrap/dist/fonts/glyphicons-halflings-regular.eot';
import numeral from 'numeral';
import 'numeral/locales/fr';
import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {signOut} from '../../actions/authentication';
import Layout from '../../components/Layout';
import PrivateRoute from '../../components/PrivateRoute';
import SideNotifications from '../../components/SideNotifications';
import '../../helpers/css/margin.css';
import CreateAlertMPG from '../AlertMPG/Create';
import AlertMPGList from '../AlertMPG/List';
import ModifyAlertMPG from '../AlertMPG/Modify';
import {CreateNewsPost} from '../CreateNewsPost';
import {CreateNotification} from '../CreateNotification';
import dailyReport from '../DailyReport';
import Home from '../Home';
import CollectionsList from '../Jerseys/CollectionsList';
// import AutoQuotation from '../AutoQuotation';
import JerseysList from '../Jerseys/List';
import JerseysPreview from '../Jerseys/Preview';
import Statistics from '../Monitoring/Statistics';
import MptClubs from '../MPT/Clubs';
import CardCreation from '../MPT/Creation';
import MptResults from '../MPT/Results';
import MptStats from '../MPT/Stats';
import {NewsFeedList} from '../NewsFeedList';
import NoMatch from '../NoMatch';
import notificationCreate from '../Notifications/Create';
import notificationModify from '../Notifications/Modify';
import {NotificationsList} from '../NotificationsList';
import MXIPlayers from '../MXI/Players';
import MXIPrize from '../Other/FL1/Prize';
import FullPlayers from '../OnSite/FullPlayers';
import Matches from '../OnSite/Matches';
import GodFatherDashboard from '../Other/Godfather/Dashboard';
import MPGTBDashboard from '../Other/MPGTB/Dashboard';
import MPPDashboard from '../Other/MPP/Dashboard';
import MPPDashboardStats from '../Other/MPP/DashboardStats';
import MPPMessaging from '../Other/MPP/Stats/Messaging';
import MPPStatsChallenges from '../Other/MPP/Stats/Challenges';
import MPPStatsLeagues from '../Other/MPP/Stats/Leagues';
import MPPDashboardTools from '../Other/MPP/DashboardTools';
import MPPChallenge from '../Other/MPP/Challenge';
import QuestionBonusForm from '../Other/MPP/QuestionBonus/Form';
import QuestionBonusList from '../Other/MPP/QuestionBonus/List';
import ResolveQuestionBonus from '../Other/MPP/QuestionBonus/Resolve';
import {MPPCreateNotification} from '../Other/MPP/Notifications/Create';
import {MPPModifyNotification} from '../Other/MPP/Notifications/Modify';
import {MPPNotificationsList} from '../Other/MPP/Notifications/List';
import SignIn from '../SignIn';
import LeagueSupport from '../Support/League';
import TournamentSupport from '../Support/Tournament';
import UserSupport from '../Support/User';
import DlPicture from '../Tools/DlPicture';
import JsonForTeam from '../Tools/JsonForTeam';
import Tds from '../Tools/Tds';
import Topflop from '../Tools/Topflop';
import {UpdateNewsPost} from '../UpdateNewsPost';
import {UpdateNotification} from '../UpdateNotification';
import UberEatsStats from '../UberEats/Stats';
import UberEatsGame from '../UberEats/Game';
import UberEatsWinners from '../UberEats/Winners';
import MPMStats from '../Other/MPM/Stats';
import MPMBadges from '../Other/MPM/Badges';
import './App.less';
import { Version } from '../Versions/Version';
import { VersionsList } from '../Versions/List';
import { Article } from '../Articles/Article';
import { ArticlesList } from '../Articles/List';

import { fetchInterceptor } from '../../helpers/endpoint';

numeral.locale('fr');

class App extends React.Component {
    

  componentDidMount() {
    fetchInterceptor(this.props.dispatch);
  }

  render() {
    const {dispatch, properties, user} = this.props;
    return (
      <div id="app">
        <BrowserRouter>
          <Switch>
            <Route path="/sign-in" component={SignIn} />
            <Layout
              title={properties.title}
              user={user}
              signOut={async () => {
                const GoogleAuth = await window.gapi.auth2.getAuthInstance();
                GoogleAuth.signOut();
                return dispatch(signOut());
              }}>
              <Switch>
                <PrivateRoute exact path="/" component={Home} />
                {/* SUPPORT */}
                <PrivateRoute path="/user-support" component={UserSupport} />
                <PrivateRoute
                  path="/league-support"
                  component={LeagueSupport}
                />
                <PrivateRoute
                  path="/tournament-support"
                  component={TournamentSupport}
                />
                {/* ON SITE */}
                {/*<PrivateRoute path='/players' component={Players}/>*/}
                <PrivateRoute path="/fullPlayers" component={FullPlayers} />
                {/*<PrivateRoute path='/suggestedQuotations' component={AutoQuotation}/>*/}
                <PrivateRoute path="/matches" component={Matches} />
                {/* MONITORING */}
                <PrivateRoute path="/statistics" component={Statistics} />
                {/* TOOLS */}
                <PrivateRoute path="/tds" component={Tds} />
                <PrivateRoute path="/topflop" component={Topflop} />
                <PrivateRoute path="/dlpicture" component={DlPicture} />
                <PrivateRoute path="/jsonForTeam" component={JsonForTeam} />
                {/* OTHER */}
                <PrivateRoute
                  path="/mpp/version/create"
                  component={Version}
                />
                <PrivateRoute
                  path="/mpp/version/update/:version"
                  component={Version}
                />
                <PrivateRoute
                  path="/mpp/version/list"
                  component={VersionsList}
                />
                <PrivateRoute
                  path="/mpp/article/create/:version?"
                  component={Article}
                />
                <PrivateRoute
                  path="/mpp/article/update/version/:version/article/:article"
                  component={Article}
                />
                <PrivateRoute
                  path="/mpp/article/list"
                  component={ArticlesList}
                />
                <PrivateRoute path="/mpp/support" component={MPPDashboard} />
                <PrivateRoute
                  path="/mpp/stats/users"
                  component={MPPDashboardStats}
                />
                <PrivateRoute
                  path="/mpp/stats/challenges"
                  component={MPPStatsChallenges}
                />
                <PrivateRoute
                  path="/mpp/stats/leagues"
                  component={MPPStatsLeagues}
                />
                <PrivateRoute
                  path="/mpp/stats/messaging"
                  component={MPPMessaging}
                />
                <PrivateRoute path="/mpp/tools" component={MPPDashboardTools} />
                <PrivateRoute path="/mpp/challenge" component={MPPChallenge} />
                <PrivateRoute
                  path="/mpp/notification/create"
                  component={MPPCreateNotification}
                />
                <PrivateRoute
                  path="/mpp/notification/update/:notificationId"
                  component={MPPModifyNotification}
                />
                <PrivateRoute
                  path="/mpp/notification/list"
                  component={MPPNotificationsList}
                />
                <PrivateRoute
                  path="/mpp/question-bonus/create"
                  component={QuestionBonusForm}
                />
                <PrivateRoute
                  path="/mpp/question-bonus/edit/:bonusQuestionId"
                  component={QuestionBonusForm}
                />
                <PrivateRoute
                  path="/mpp/question-bonus/view/:bonusQuestionId"
                  component={QuestionBonusForm}
                />
                <PrivateRoute
                  path="/mpp/question-bonus/resolve/:bonusQuestionId"
                  component={ResolveQuestionBonus}
                />
                <PrivateRoute
                  path="/mpp/question-bonus/list"
                  component={QuestionBonusList}
                />
                <PrivateRoute path="/mpp" component={MPPDashboard} />
                <PrivateRoute path="/mpgtb" component={MPGTBDashboard} />
                <PrivateRoute
                  path="/godfather"
                  component={GodFatherDashboard}
                />
                {/* ALERT */}
                <PrivateRoute
                  path="/alertMPG/create"
                  component={CreateAlertMPG}
                />
                <PrivateRoute path="/alertMPG/list" component={AlertMPGList} />
                <PrivateRoute
                  path="/alertMPG/modify/:alertId"
                  component={ModifyAlertMPG}
                />
                {/* MPT */}
                <PrivateRoute path="/mpt/stats" component={MptStats} />
                <PrivateRoute path="/mpt/creation" component={CardCreation} />
                <PrivateRoute path="/mpt/clubs" component={MptClubs} />
                <PrivateRoute path="/mpt/results" component={MptResults} />
                {/* Jerseys */}
                <PrivateRoute path="/jerseys/list" component={JerseysList} />
                <PrivateRoute
                  path="/jerseys/collections"
                  component={CollectionsList}
                />
                <PrivateRoute
                  path="/jerseys/preview"
                  component={JerseysPreview}
                />
                {/* NOTIFICATIONS */}
                <PrivateRoute
                  path="/notification/create"
                  component={notificationCreate}
                />
                <PrivateRoute
                  path="/notification/modify/:notificationId"
                  component={notificationModify}
                />
                {/* DAILY REPORT */}
                <PrivateRoute path="/daily-report" component={dailyReport} />
                <PrivateRoute
                  path="/notifications/create"
                  component={CreateNotification}
                />
                <PrivateRoute
                  path="/notifications/update/:notificationId"
                  component={UpdateNotification}
                />
                <PrivateRoute
                  path="/notifications/list"
                  component={NotificationsList}
                />
                <PrivateRoute
                  path="/news-feed/create"
                  component={CreateNewsPost}
                />
                <PrivateRoute
                  path="/news-feed/update/:newsPostId"
                  component={UpdateNewsPost}
                />
                <PrivateRoute path="/news-feed/list" component={NewsFeedList} />
                {/* MPG VERSIONS */}
                <PrivateRoute
                  path="/version/create"
                  component={Version}
                />
                <PrivateRoute
                  path="/version/update/:version"
                  component={Version}
                />
                <PrivateRoute
                  path="/version/list"
                  component={VersionsList}
                />
                <PrivateRoute
                  path="/article/create/:version?"
                  component={Article}
                />
                <PrivateRoute
                  path="/article/update/version/:version/article/:article"
                  component={Article}
                />
                <PrivateRoute
                  path="/article/list"
                  component={ArticlesList}
                />
                {/* MXI */}
                <PrivateRoute path="/mxi/players" component={MXIPlayers} />
                <PrivateRoute path="/mxi/prize" component={MXIPrize} />
                {/* GOAT Uber Eats */}
                <PrivateRoute
                  path="/uber-eats/stats"
                  component={UberEatsStats}
                />
                <PrivateRoute path="/uber-eats/game" component={UberEatsGame} />
                <PrivateRoute
                  path="/uber-eats/winners"
                  component={UberEatsWinners}
                />
                {/* MPM */}
                <PrivateRoute path="/mpm/stats" component={MPMStats} />
                <PrivateRoute path="/mpm/badges" component={MPMBadges} />
                <Route component={NoMatch} />
              </Switch>
            </Layout>
            <Route component={NoMatch} />
          </Switch>
        </BrowserRouter>
        <SideNotifications />
      </div>
    );
  }
}

export default connect(
  state => ({
    properties: state.app.properties,
    user: state.authentication || {},
  }),
  dispatch => ({dispatch}),
)(App);



// WEBPACK FOOTER //
// ./src/pages/App/index.js